import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginModel, RegisterModel } from 'src/app/models/login/login.model';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  user: LoginModel;
  isLogin: boolean;
  loginResponse: any;
  Loader: boolean = false;
  productId: number = 0;
  resendConformationLoader: boolean = false;
  returnUrl: string;
  //register
  registeruser: RegisterModel = new RegisterModel();
  LoaderRegister: boolean = false;
  registerForm: boolean = true;
  registerDemo: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, private localstorage: LocalstorageService, private alertify: AlertifyService, private router: Router, private _loginService: LoginService) {
    this.localstorage.setMenu("1");
    this.user = new LoginModel();
    this.activatedRoute.queryParams.subscribe((param) => {
      this.returnUrl = param.return;
    });
  }

  ngOnInit() {
  }

  onSubmit(): void {
    if (this.user.UserName == "" || this.user.UserName == null || this.user.UserName == undefined) {
      this.alertify.error("Email is required");
      return;
    }
    if (this.user.Password == "" || this.user.Password == null || this.user.Password == undefined) {
      this.alertify.error("Password is required");
      return;
    }
    this.resendConformationLoader = false;
    this.Loader = true;
    this._loginService.login(this.user).subscribe(res => {
      var responseData = JSON.parse(res._body);
      if (responseData.isSuccess) {
        this.user = responseData.responseData;
        this.localstorage.setToken(responseData.responseData.token);
        this.localstorage.setname(responseData.responseData.firstName);
        this.localstorage.setUserRole(responseData.responseData.usertype);
        this.localstorage.setUserId(responseData.responseData.userId);
        this.alertify.success("Login Successfully");
        this.resendConformationLoader = true;
        this.Loader = false;
        if (this.returnUrl) {
          window.open(this.returnUrl, "_self");

        } else if (responseData.responseData.usertype == '1') {
          this.router.navigate(['dashboard']);
        } else {
          this.router.navigate(['home-page']);
        }
      }
      else {
        this.resendConformationLoader = false;
        this.alertify.error(responseData.responseMessage);
        this.Loader = false;
        if (responseData.responseData == "Please verify your account") {
          this.resendConformationLoader = true;
        }
        else {
          this.resendConformationLoader = false;
        }
      }
      this.isLogin = false;
    },
    )
  }

  cancel() {
    this.router.navigate(['home-page']);
  }

  onSubmitRegister(): void {
    if (this.registeruser.FirstName == undefined || this.registeruser.FirstName == null || this.registeruser.FirstName == "") {
      this.alertify.error("First Name is required");
      return;
    }
    if (this.registeruser.LastName == "" || this.registeruser.LastName == null || this.registeruser.LastName == undefined) {
      this.alertify.error("Last Name is required");
      return;
    }
    if (this.registeruser.Email == "" || this.registeruser.Email == null || this.registeruser.Email == undefined) {
      this.alertify.error("Email is required");
      return;
    }
    if (this.registeruser.Password == "" || this.registeruser.Password == null || this.registeruser.Password == undefined) {
      this.alertify.error("Password is required");
      return;
    }
    this.LoaderRegister = true;
    this.registerForm = true;
    this.registerDemo = false;
    this._loginService.Register(this.registeruser).subscribe(res => {
      var responseData = JSON.parse(res._body);
      if (responseData.isSuccess) {
        this.LoaderRegister = false;
        this.registerForm = false;
        this.registerDemo = true;
      }
      else {
        this.alertify.error(responseData.responseMessage);
      }
      this.LoaderRegister = false;
    }
    )
  }

  loginPage() {
    this.registeruser.FirstName = "";
    this.registeruser.LastName = "";
    this.registeruser.Email = "";
    this.registeruser.Password = "";
    this.registerDemo = false;
  }

}
